module.exports = __webpack_public_path__ + "img/baby_spirits_tab_highlight.f5a04692.png";